<template>
  <div class="tw-toast-container">
    <TwToast v-for="toast in toasts" :key="toast.id" v-bind="toast" @dismiss="removeToast" />
  </div>
</template>

<script>
import toastService from './toastService';
import TwToast from './TwToast.vue';

export default {
  name: 'TwToastContainer',

  components: { TwToast },

  data() {
    return {
      toasts: [],
    };
  },

  mounted() {
    toastService.flush(this);
  },

  methods: {
    addToast(opts) {
      this.toasts.push({
        id: `toast-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
        type: 'info',
        title: '',
        message: '',
        duration: 5000,
        ...opts,
      });
    },

    removeToast(id) {
      this.toasts = this.toasts.filter((t) => t.id !== id);
    },
  },
};
</script>
